// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3ZU-6","inputDescription":"styles_inputDescription__2UXvt"};